import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { AuthService } from "./auth.service";
import { ToastService } from "@shared/third-part-modules/toastr/toast.service";
import { LocalStorage } from '@shared/services/storages/local-storage';

@Injectable({providedIn: "root"})
export class AuthGuard {
  constructor(
    private authService: AuthService,
    private toastService: ToastService,
  ) {}

  // eslint-disable-next-line
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const userData = this.authService.userData();

    if (!userData) {
      this.authService.logout();
      return false;
    }
    // if (!userData.roles.length) {
    //   this.toastService.error("YOU_DONT_HAVE_ANY_ROLES");
    //   this.authService.logout();
    // }
  }
}
